import React from 'react'
import { FormMicSiteArea } from './FormMicSiteArea';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';



export const ModalMicSiteArea = (props) => {

    const {
        modal, modalTitle, toggle, method,
        validaciones,
        name, id_mic_site, sites,
        handleInputChange, loading,
        saveCreate, saveUpdate, saveDelete,

        closeDialog
    } = props;

    return (
        <Dialog
            // header={modalTitle}
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-hotel f-24"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v3`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdate}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}>
                        Cancelar
                    </Button>
                </>
            }

        >

            {
                method === "create"
                    ? <FormMicSiteArea
                        button={"Crear sitio"}
                        {...{ toggle, loading, handleInputChange, sites, validaciones, closeDialog, methodAction: saveCreate, sites }}
                    />
                    : (method === "update")
                        ?
                        <FormMicSiteArea
                            button={"Actualizar sitio"}
                            {...{ toggle, loading, handleInputChange, id_mic_site, sites, validaciones, closeDialog, methodAction: saveUpdate, name, sites }} />
                        :
                        null
            }
        </Dialog>
    )
}
